import { kea } from "kea";

import api from '../utils/api';

export const rolelogic = kea({
	actions: {
		fetch: true,

		set: (roles) => ({ roles }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		roles: [null, {
			set: (_, { roles }) => roles,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async (_, breakpoint) => {
			await breakpoint(300);
			let url = '/role';
			let res;
			try {
				res = await api({ url, method: 'get' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) actions.set(json.payload);
			else actions.setError(json.error);
		}
	})
});

export default rolelogic;